import { render, staticRenderFns } from "./TopStatistics.vue?vue&type=template&id=3956a752&scoped=true&"
var script = {}
import style0 from "./TopStatistics.vue?vue&type=style&index=0&id=3956a752&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3956a752",
  null
  
)

export default component.exports